// services/menuService.js
import api from './api';
 const fetchMenu = async () => {
  try {
    const response = await api.get("TopMenu/gettopmenu"); // example: /menus endpoint
    return response.data.data.categories;
  } catch (error) {
    console.error('Failed to fetch menu:', error);
    return [];
  }
};

 const fetchApplications = async () => {
  try {
    const response = await api.get("TopMenu/getapplication"); // example: /menus endpoint
    return response.data.data.categories;
  } catch (error) {
    console.error('Failed to fetch menu:', error);
    return [];
  }
};

const fetchSearchedProduct = async (QueryText) => {
  try {
    const response = await api.get(`ProductDetails/getsearchproductbykeyword/${QueryText}/0/0/10/0/0`); // example: /menus endpoint
   console.log(response.data.data);
    return response.data.data;
    
  } catch (error) {
    console.error('Failed to fetch menu:', error);
    return [];
  }
};
export default {
  fetchApplications,
  fetchMenu,
  fetchSearchedProduct
};